<template>
  <div>
    <b-btn
      variant="primary btn-round add-button"
      class="ml-3 col-auto"
      v-click-outside="() => (this.enabled = false)"
      @click="enabled = !enabled"
      title="Add New Object on Map"
      ref="add"
      ><span class="ion ion-md-add"></span>
      <span class="add-text"> Add New</span>
    </b-btn>
    <AppDropdown v-if="enabled" :dst-el="$refs.add">
      <ul class="more-menu" @click.stop>
        <li
          class="dropdown-item"
          v-for="icon in primaryPointIcons"
          :key="icon.id"
          @click="emitDraw(icon.id)"
          @touchend.stop.prevent="$emit('startDraw', icon.id)"
        >
          {{ icon.name }}
        </li>
        <li class="dropdown-divider"></li>
        <li
          class="dropdown-item"
          v-for="icon in otherPointIcons"
          :key="icon.id"
          @click="emitDraw(icon.id)"
          @touchend.stop.prevent="$emit('startDraw', icon.id)"
        >
          {{ icon.name }}
        </li>
      </ul>
    </AppDropdown>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { canCreateMainPoint, filterDesk, POINT_ICONS, POINTS_MAIN_ORDERED } from '@/store/modules/point'
import AppDropdown from '@/components/shared/AppDropdown'

const EXCLUDED_ICONS = [POINT_ICONS.DESK_BUSY]

export default {
  name: 'MapDrawMenu',
  components: {
    AppDropdown
  },
  props: {
    hasDesk: {
      type: Boolean,
      default: false
    },
    hasArea: {
      type: Boolean,
      default: false
    },
    hasEmployee: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      enabled: false
    }
  },
  computed: {
    ...mapGetters('rbac', ['can']),
    ...mapState('pointIcon', ['entities']),
    ...mapGetters('pointIcon', ['pointIcons']),
    ...mapGetters('rbac', ['canBookForOthers']),
    availablePointIcons() {
      return this.pointIcons.filter((v) => {
        if (!this.filterDesk(v.id)) return false
        if (!this.hasArea && v.id === POINT_ICONS.AREA) return false
        return !EXCLUDED_ICONS.includes(v.id)
      })
    },
    primaryPointIcons() {
      return POINTS_MAIN_ORDERED.filter((id) => {
        if (!canCreateMainPoint(id, this.can)) return false
        if ((!this.hasEmployee || !this.canBookForOthers) && id === POINT_ICONS.EMPLOYEE) return false
        if (!this.filterDesk(id)) return false
        return this.hasArea || id !== POINT_ICONS.AREA
      }).map((id) => this.entities.pointIcons[id])
    },
    otherPointIcons() {
      return this.availablePointIcons.filter((v) => !POINTS_MAIN_ORDERED.includes(v.id)).sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    emitDraw(id) {
      this.$emit('startDraw', id)
      this.enabled = false
    },
    filterDesk(id) {
      return filterDesk(id, this.hasDesk)
    }
  }
}
</script>

<style lang="scss">
.add {
  &-button {
    white-space: nowrap;
  }
  &-text {
    @media (max-width: 400px) {
      display: none;
    }
  }
}
</style>
